import { render, staticRenderFns } from "./select-supplier.vue?vue&type=template&id=54813b17&"
import script from "./select-supplier.vue?vue&type=script&lang=js&"
export * from "./select-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports